import { Image, ImageSource } from 'expo-image';
import { Platform, StyleSheet, View } from 'react-native';

import Text from '../Text';
import { router } from 'expo-router';
import { i18n } from '@/utils/i18n';

interface ChatVolunteerEventRoomHeaderProps {
  thumbnail: string | number | ImageSource | ImageSource[] | string[] | null | undefined;
  title: string;
  volunteerId: string;
  subtitle: string;
  footer: string;
}

const ChatVolunteerEventRoomHeader = ({
  thumbnail,
  title,
  volunteerId,
  subtitle,
  footer
}: ChatVolunteerEventRoomHeaderProps) => {
  return (
    <View style={styles.mainContainer}>
      <Image source={thumbnail} style={styles.thumb} />
      <View style={styles.content}>
        <View style={styles.titleContainer}>
          <Text numberOfLines={1} fontWeight="700" style={styles.title}>
            {title}
          </Text>
        </View>
        <Text numberOfLines={1} style={styles.subtitle}>
          {`${subtitle.replace(`- ${i18n.t('mix.volunteer_event')}`, '')}- `}
          <Text
            numberOfLines={1}
            style={[styles.subtitle, { color: '#0a7ea4', textDecorationLine: 'underline' }]}
            onPress={() =>
              router.navigate({
                pathname: '/(app)/volunteerDetail/[volunteerId]',
                params: {
                  volunteerId: volunteerId
                }
              })
            }>
            {i18n.t('mix.volunteer_event')}
          </Text>
          {` - ${footer}`}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    width: Platform.OS === 'web' ? '100%' : '88%',
    flexDirection: 'row',
    justifyContent: Platform.OS === 'android' ? 'flex-start' : 'center',
    paddingLeft: Platform.OS === 'android' ? 10 : null,
    alignItems: 'center',
    gap: 10
  },

  thumb: {
    width: 36,
    height: 36,
    borderRadius: 20
  },

  content: {
    gap: 2
  },

  titleContainer: {
    flexDirection: 'row',
    maxWidth: '100%'
  },

  title: {
    color: 'black'
  },

  subtitle: {
    maxWidth: '100%'
  }
});

export default ChatVolunteerEventRoomHeader;
